// What the multi builder is showing, on its own so the share card can read it
// without importing the store (src/lib/share-pad.js is prefetched at mount and
// must draw synchronously on the tap). Written by src/lib/stores/ask.js only.

import { reactive } from 'vue';

/**
 * What is on screen for the current ask.
 *
 * `batches` is every set of tickets shown since the ask last changed, in order;
 * `shown` is the key of every multi in them, which is what "Another one" leaves
 * out. `legacy` is a model strategy's own tickets, for a preset that is one.
 */
export const askView = reactive({
  key: null,
  interpretation: '',
  batches: [],
  unsatisfied: null,
  relaxed: [],
  freshness: [],
  legacy: null,
  firstResultMs: null,
  // How many distinct multis fit the ask: the length of the ranked list.
  matching: 0,
  // Every distinct multi has been shown.
  exhausted: false,
});

